import type { InsightImpact } from './types'

/** Anything the shared impact formatter accepts. */
export type ImpactLike = InsightImpact | number | null | undefined

function round2(n: number): string {
  return String(Math.round(n * 100) / 100)
}

/**
 * Canonical operator-facing impact label. Leads with the metric when one is
 * present (e.g. "10 h downtime"), otherwise the context phrase; returns ''
 * when there is nothing meaningful to show.
 */
export function formatImpact(impact: ImpactLike): string {
  if (impact == null) return ''
  if (typeof impact === 'number') {
    return Number.isFinite(impact) ? round2(impact) : ''
  }
  const ctx = impact.context?.trim() ?? ''
  const unit = impact.unit?.trim() ?? ''
  const value = impact.value
  if (typeof value === 'number' && Number.isFinite(value)) {
    const metric = unit ? `${round2(value)} ${unit}` : round2(value)
    return ctx ? `${metric} · ${ctx}` : metric
  }
  return ctx
}
